module.exports = __webpack_public_path__ + "img/area-add-1-02.b95936b.jpg";